import React, { useState, useMemo } from 'react';
import { View, ScrollView } from 'react-native';
import { getFullMachineName } from '../../../common/utils/machine';
import sortServiceDockets from '../../../common/utils/serviceDocket/sortServiceDockets';
import { Dialog } from '../../components';
import { SecondaryButton, TickRow } from '../../design/components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const DocketSelector = ({
	serviceDockets,
	selectedDocketIds,
	setSelectedDocketIds,
}) => {
	const [internallySelectedDockets, setInternallySelectedDockets] = useState(selectedDocketIds);
	const styles = useThemedStyles(createStyles);

	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const toggleDocket = (docketId, isSelected) => () => {
		setInternallySelectedDockets(currentDocketIds => (
			isSelected ? currentDocketIds.filter(id => id !== docketId) : [...currentDocketIds, docketId]
		));
	};

	const onClose = () => {
		setIsDialogOpen(false);
		setSelectedDocketIds(internallySelectedDockets);
	};

	// Sort dockets by service time if completed, and by location if not
	const sortedDockets = useMemo(() => [...serviceDockets].sort(sortServiceDockets), [serviceDockets]);

	return (
		<View>
			<SecondaryButton
				label={internallySelectedDockets.length > 0 ? `${internallySelectedDockets.length} POS selected` : 'Select POS'}
				icon="check-square"
				onPress={() => setIsDialogOpen(true)}
			/>
			<Dialog
				shouldShowCloseIcon={false}
				noPadding={true}
				isOpen={isDialogOpen}
				shouldShowOkButton={true}
				onClose={onClose}
			>
				<View>
					<View style={styles.headerContainer}>
						<SecondaryButton
							style={styles.headerButton}
							label="Select all"
							onPress={() => setInternallySelectedDockets(serviceDockets.filter(docket => docket.pickList).map(docket => docket.id))}
						/>
						<SecondaryButton
							style={styles.headerButton}
							label="Unselect all"
							onPress={() => setInternallySelectedDockets([])}
						/>
					</View>
					<ScrollView
						style={styles.list}
						contentContainerStyle={styles.listContent}
						scrollIndicatorInsets={{ right: 1 }}
					>
						{
							sortedDockets.map(docket => {
								const isSelected = internallySelectedDockets.includes(docket.id);
								return (
									<TickRow
										key={docket.id}
										title={getFullMachineName(docket.machine, docket.machine.place, docket.machine.location)}
										subtitle={docket.pickList ? undefined : 'No pick list'}
										checked={isSelected}
										onToggle={toggleDocket(docket.id, isSelected)}
										disabled={!docket.pickList}
									/>
								);
							})
						}
					</ScrollView>
				</View>
			</Dialog>
		</View>
	);
};

const createStyles = ({ ui: { colors, space } }) => ({
	headerContainer: {
		flexDirection: 'row',
		gap: space.sm,
		padding: space.md,
		borderBottomColor: colors.border,
		borderBottomWidth: 1,
	},
	headerButton: {
		flex: 1,
	},
	list: {
		height: 300,
	},
	listContent: {
		gap: space.sm,
		padding: space.md,
	},
});

export default DocketSelector;
